import React, { useEffect, useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Card, CardHeader, CardContent, Paper, Typography, Grid, Link } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { actionGetExtraItem, actionGetExtraItemAfterMembership } from 'actions';
import { actionShopCartAddEventWithTourHold, actionShopCartResetError, actionSetAddToCart } from 'actions';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { genfunction } from '../../helpers';
import ReactHtmlParser from 'react-html-parser';
import ErrorHandling from '../ErrorHandling/ErrorHandling';
import ExtraItemsProducts from 'components/CalendarControls/ExtraItemsProducts';
import BookingUDFields from 'components/CalendarControls/BookingUDFields';
import Chaperone from './Chaperone';
import PaymentSelection from './PaymentSelection';
import { actionStartAppLoader, actionEndAppLoader } from 'actions';


const { DisplayBookingTypeInfoCharacters, OrderItemsInCartError, PurchaseAsOrganizationButton, InvalidGroupSizeMsg } = window['runConfig'];

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  tourheaderbox: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  arrowBtn: {
    float: 'left',
    marginLeft: '10px',
    marginTop: '3px'
  },
  BookingInfoCls: {
    paddingTop: '5px',
    paddingLeft: '16px',
    paddingRight: '16px',
    textAlign: 'justify'
  },
  readmoreBtn: {
    margin: 'auto',
    marginBottom: '10px',
    //  marginTop: '5px'
  }
}));

const ExtraItemDrawer = (props) => {
  const classes = useStyles();
  const [errorMsg, seterrorMsg] = useState("");
  const [isredirectclicked, setisredirectclicked] = useState(false);
  const ref = useRef();

  const dispatch = useDispatch();
  const shopCartError = useSelector(state => state.reducerShopCart.error);
  const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
  const apiData = useSelector(state => state.reducerExtraItems.extraItem);
  const tourEvents = useSelector(state => state.reducerExtraItems.extramItems);
  const isAddToCart = useSelector(state => state.reducerExtraItems.isAddToCart);
  const cartEvents = useSelector(state => state.reducerShopCart.events);
  const bookingTypes = useSelector(state => state.reducerBookingTypes.bookingTypes);
  const bkngType = bookingTypes.filter(x => x.BookingTypeID == props.bookingtypeID)[0];
  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const [readmorebtnText, setreadmorebtnText] = useState('Read More');
  const bookingUDFS = useSelector(state => state.reducerBookingUserDefinedFields);
  const organizationList = useSelector(state => state.reducerOrganizationSection.organizationlist);
  const [saveBtn, setsaveBtn] = React.useState(false);

  const [state, setState] = useState({
    paymentOption: "",
    amountSelected: 0,

  });

  useEffect(() => {

    if (isredirectclicked) {
      if (shopCartError.length < 1) {
        props.callCheckout();
      }
      if (shopCartError.length > 0) {
        seterrorMsg(shopCartError);
        setisredirectclicked(false);
      }
    }

  }, [shopCartError, cartEvents]);

  useEffect(() => {

    if (props.isEditEvent)
      actionSetAddToCart(dispatch);

  }, [isAddToCart, apiData])

  useEffect(() => {

    if (bkngType.PayDepositOnly === true)
      onChangePaymentOption("MinimumPay", genfunction.MinimumDepositCalculation(apiData, props.tourEventId, bkngType.ChaperoneTourProductID))

  }, [apiData]);

  const onChangePaymentOption = (paymentOptionSelected, paymentAmountSelected) => {
    setState({ ...state, amountSelected: genfunction.IsNotNullOrEmptyOrUndefined(paymentAmountSelected) ? parseFloat(paymentAmountSelected) : 0, paymentOption: paymentOptionSelected });
  }


  const redirectCall = () => {

    if (orderProducts && orderProducts.length > 0) {
      seterrorMsg(OrderItemsInCartError);
      return;
    }

    if (ValidateBookingRequiredFields() && (genfunction.IsNotNullOrEmptyOrUndefined(props.groupSize) ? ValidateGroupQuanity() : ValidateQuanity())
      && (genfunction.IsShowPartPaymentSelection(apiData, bkngType, props.groupSize) ? ref.current.validateAmountSelected() : true)) {

      setisredirectclicked(true);

      setsaveBtn(true);

      setTimeout(() => {
        setsaveBtn(false);
      }, 1000)

      let filterdata = { ...apiData };
      filterdata.TourProducts = filterdata.TourProducts.filter(product => product.Quantity > 0);
      let cartdata = [...cartEvents];

      if (filterdata && filterdata.hasOwnProperty('BookingTypeID')) {
        let usealternamteMerchant = false;
        if (bkngType && bkngType.hasOwnProperty('UseAlternateMerchant')) {
          usealternamteMerchant = bkngType.UseAlternateMerchant;
        }

        filterdata.UseAlternateMerchant = usealternamteMerchant;

      }
      actionShopCartAddEventWithTourHold(dispatch, filterdata, cartdata, props.organizationID, props.groupSize, state.paymentOption, state.amountSelected, props.isEditEvent);
      //props.callCheckout();
    }
  }


  const ValidateQuanity = () => {
    let MinTicket = bkngType.MinimumTickets
    let MaxTicket = bkngType.MaximumTickets;

    let CartQty = 0;
    let NewQty = 0;
    let TotalTicketCount = 0;
    let SeatsAvailable = tourEvents.filter(x => x.TourEventID === props.tourEventId)[0].SeatsAvailable;

    if (cartEvents && cartEvents.length > 0) {

      let cartTourEvent = cartEvents.find(x => x.TourEventID == apiData.TourEventID);
      if (cartTourEvent && cartTourEvent.TourProducts.length > 0) {
        CartQty = cartTourEvent.TourProducts.filter(p => p.AffectsCapacity).reduce((a, b) => {
          let aqty = a.Quantity === undefined ? 0 : a.Quantity;
          let bqty = b.Quantity === undefined ? 0 : b.Quantity;
          let newobj = { Quantity: aqty + bqty }
          return newobj;
        }).Quantity;
      }
    }

    NewQty = apiData.TourProducts.filter(p => p.AffectsCapacity).reduce((a, b) => {
      let aqty = a.Quantity === undefined ? 0 : a.Quantity;
      let bqty = b.Quantity === undefined ? 0 : b.Quantity;
      let newobj = { Quantity: aqty + bqty }
      return newobj;
    }).Quantity;

    TotalTicketCount = props.isEditEvent ? NewQty : CartQty + NewQty;

    SeatsAvailable = props.isEditEvent ? CartQty + SeatsAvailable : SeatsAvailable;

    if (SeatsAvailable == 0 || apiData.BookNowOption != "Book Now" && !props.isEditEvent) {
      seterrorMsg("Tickets no longer available, please choose another time");
      return false;
    }
    else if (NewQty > SeatsAvailable) {
      seterrorMsg("Maximum of " + SeatsAvailable + " tickets available");
      return false;
    }
    else if (TotalTicketCount < MinTicket) {
      seterrorMsg("Minimum tickets per order is " + MinTicket)
      return false;
    }
    else if (TotalTicketCount > MaxTicket) {
      seterrorMsg("Maximum of " + MaxTicket + " tickets allowed")
      return false;
    }
    else {
      return true;
    }
  }

  const ValidateGroupQuanity = () => {
    const groupTicket = props.groupSize.toLowerCase().split(" to ");

    let MinTicket = groupTicket[0];
    let MaxTicket = groupTicket[1];

    let CartQty = 0;
    let NewQty = 0;
    let TotalTicketCount = 0;
    let ChaperoneQty = 0;
    let SeatsAvailable = 0;

    if (cartEvents && cartEvents.length > 0) {

      let cartTourEvent = cartEvents.find(x => x.TourEventID == apiData.TourEventID);
      if (cartTourEvent && cartTourEvent.TourProducts.length > 0) {
        CartQty = cartTourEvent.TourProducts.filter(p => p.AffectsCapacity).reduce((a, b) => {
          let aqty = a.Quantity === undefined ? 0 : a.Quantity;
          let bqty = b.Quantity === undefined ? 0 : b.Quantity;
          let newobj = { Quantity: aqty + bqty }
          return newobj;
        }).Quantity;
      }
    }

    NewQty = apiData.TourProducts.filter(p => p.AffectsCapacity
      && p.TourProductID != bkngType.ChaperoneTourProductID).reduce((a, b) => {
        let aqty = a.Quantity === undefined ? 0 : a.Quantity;
        let bqty = b.Quantity === undefined ? 0 : b.Quantity;
        let newobj = { Quantity: aqty + bqty }
        return newobj;
      }).Quantity;


    let chaperoneTourProduct = apiData.TourProducts.filter(p => p.AffectsCapacity && p.TourProductID === bkngType.ChaperoneTourProductID);
    if (chaperoneTourProduct && chaperoneTourProduct.length > 0) {

      ChaperoneQty = apiData.TourProducts.filter(p => p.AffectsCapacity && p.TourProductID === bkngType.ChaperoneTourProductID)[0].Quantity;
    }

    TotalTicketCount = NewQty + ChaperoneQty;

    SeatsAvailable = props.isEditEvent ? CartQty + apiData.SeatsAvailable : apiData.SeatsAvailable;

    if (NewQty < MinTicket || NewQty > MaxTicket) {
      seterrorMsg(InvalidGroupSizeMsg + props.groupSize)
      return false;
    }

    else if (TotalTicketCount > SeatsAvailable) {
      seterrorMsg("Maximum of " + SeatsAvailable + " tickets available");
      return false;
    }
    else if (SeatsAvailable == 0 || (apiData.BookNowOption != "Book Now" && !props.isEditEvent)) {
      seterrorMsg("Tickets no longer available, please choose another time");
      return false;
    }

    else
      return true;
  }


  const ShowMoreInfoClick = () => {

    if (readmorebtnText === 'Read More') {
      setShowMoreInfo(true);
      setreadmorebtnText('Read Less');
    }
    else {
      setShowMoreInfo(false);
      setreadmorebtnText('Read More');
    }
  }


  const replaceEscapeCharacters = (item) => {
    var itemValue = item.split("\\r\\n").join("<br />");
    itemValue = itemValue.split("\\").join("");
    return itemValue;
  }

  useEffect(() => {

    if (tourEvents && tourEvents.length > 0 && tourEvents !== 'nocontent' && tourEvents.find(x => x.TourEventID === props.tourEventId)) {
      let organizationCostRate = genfunction.IsNotNullOrEmptyOrUndefined(props.organizationID) && organizationList.length > 0 ? organizationList.filter(x => x.CustomerID === props.organizationID)[0].CostRateID : "";

      if (!props.isEditEvent || (!props.isContinueToExtraItemDrawer && apiData.TourEventID !== props.tourEventId)) {
        actionGetExtraItem(dispatch, props.tourEventId, props.ismembershipapplied, props.membercostrate, props.isIDME, props.isIDMECostrate, organizationCostRate)
      }
      else if (props.isEditEvent && !props.isContinueToExtraItemDrawer && (props.ismembershipapplied || props.isIDME)) {
        actionGetExtraItemAfterMembership(dispatch, apiData, props.tourEventId, props.ismembershipapplied, props.membercostrate, props.isIDME, props.isIDMECostrate, organizationCostRate)
      }
    }

  }, [tourEvents]);

  useEffect(() => {

    if (apiData && apiData.TourEventID !== props.tourEventId)
      actionStartAppLoader(dispatch);

    else
      actionEndAppLoader(dispatch);
  }, [apiData])


  const errorcancelhandle = () => {
    seterrorMsg("");
    actionShopCartResetError(dispatch);
  }

  const GetBookingInfo = (bookingInfo) => {

    if (showMoreInfo) {
      return bookingInfo.substring(0, bookingInfo.length - 1);
    }

    return bookingInfo.substring(0, DisplayBookingTypeInfoCharacters);
  }


  const ValidateBookingRequiredFields = () => {
    let validate = true;

    if (bookingUDFS.bookingUDFs.length > 0 && bookingUDFS.bookingUDFs.filter(x => x.BookingTypeID === props.bookingtypeID).length > 0) {
      let booking = bookingUDFS.bookingUDFs.filter(x => x.BookingTypeID == props.bookingtypeID)[0];

      if (booking.UDFCategories && booking.UDFCategories.length > 0) {
        booking.UDFCategories.map(udfCategories => {

          let udfCat = { ...udfCategories };

          if (udfCat.UserDefinedFields && udfCat.UserDefinedFields.length > 0 && validate) {
            udfCat.UserDefinedFields.filter(x => x.toureventID > 0).map(UDF => {

              if (UDF.IsRequired && UDF.hasOwnProperty('Value') && validate) {

                if ((UDF.UDFType === "Text" || UDF.UDFType === "Decimal" || UDF.UDFType === "Date") && UDF.Value.length < 1) {
                  validate = false;
                  seterrorMsg('Please fill all required UDFs.');
                }
                else if (UDF.UDFType === "Bit" && (UDF.Value === false || UDF.Value.length < 1)) {
                  validate = false;
                  seterrorMsg('Please fill all required UDFs.');
                }
              }
            });
          }
        });
      }
    }

    return validate;
  }
  return (
    <div>
      <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />
      <Grid container>
        <Paper className={classes.root}>
          <Typography className={classes.tourheaderbox} align="center" variant="h2" style={{ padding: "10px" }}>
            {window.matchMedia("(min-width: 600px)").matches ? "" : <ArrowBackIosIcon className={classes.arrowBtn} onClick={() => { props.toggleDrawer("right", false) }} />}
            {apiData.hasOwnProperty("EventName") ? apiData.EventName : null}
          </Typography>
          <Grid container alignItems="center" item xs={12} ms={12} lg={12}>
            <Typography variant="subtitle1" color="textSecondary" className={classes.BookingInfoCls}>
              {bkngType !== undefined && bkngType.hasOwnProperty("BookingTypeInfo") ? ReactHtmlParser(replaceEscapeCharacters(GetBookingInfo(bkngType.BookingTypeInfo ? bkngType.BookingTypeInfo : ""))) : null}
            </Typography>


            <Link
              className={classes.readmoreBtn}
              component="button"
              variant="body2"
              onClick={() => ShowMoreInfoClick()}
              style={{ display: bkngType.BookingTypeInfo && bkngType.BookingTypeInfo.length < DisplayBookingTypeInfoCharacters ? 'none' : 'block' }}
            >
              {readmorebtnText}
            </Link>

          </Grid>
          {bkngType.AllowedCustomerTypes === 'All' && !bkngType.ShowTourProductsBasedOnGroupSize && !genfunction.IsNotNullOrEmptyOrUndefined(props.organizationID) ?
            <Grid style={{ paddingBottom: "20px" }} container alignItems="center" item xs={12} ms={12} lg={12}>
              <Grid item xs={2} ms={2} lg={2}></Grid>
              <Grid item xs={8} ms={8} lg={8} align='center'>
                <Button variant="contained" size="small" color="primary" onClick={() => props.goToExtraItemOrGroupDrawer(false)}>{PurchaseAsOrganizationButton}</Button>
              </Grid>
              <Grid item xs={2} ms={2} lg={2}></Grid>
            </Grid>
            : null}
        </Paper>

        <Card style={{ borderRadius: "0", width: "100%" }}>

          <ExtraItemsProducts allowQuantityChange={true}
            tourEventId={props.tourEventId}
            ismembershipapplied={props.ismembershipapplied}
            membercostrate={props.membercostrate}
            isIDME={props.isIDME}
            isIDMECostrate={props.isIDMECostrate}
            bookingtypeID={props.bookingtypeID} groupSize={props.groupSize}
            isEditEvent={props.isEditEvent}
          />

          {bkngType.AddChaperoneTickets && bkngType.ShowTourProductsBasedOnGroupSize ? <Chaperone tourEventId={props.tourEventId} bookingtypeID={props.bookingtypeID} /> : null}

          <BookingUDFields key={props.tourEventId} toureventID={props.tourEventId} bookingtypeID={props.bookingtypeID} />

          {genfunction.IsShowPartPaymentSelection(apiData, bkngType, props.groupSize) ? <PaymentSelection isEditEvent={props.isEditEvent} toureventID={props.tourEventId}
            ref={ref} onChangePaymentOption={onChangePaymentOption} paymentOption={state.paymentOption} amountSelected={state.amountSelected}
            bookingtypeID={props.bookingtypeID}  ></PaymentSelection> : null}

          <CardContent>

            <Grid style={{ paddingTop: "20px" }} container alignItems="center" item xs={12} ms={12} lg={12}>

              <Grid item xs={8} ms={8} lg={8}>
                <Typography variant="h5" style={{ marginLeft: "20px", marginBottom: "20px" }}>Tax =  {genfunction.ccyFormat(apiData.TaxAmount ? apiData.TaxAmount : 0)}</Typography>
              </Grid>

              <Grid item xs={8} ms={8} lg={8}>
                <Typography variant="h5" style={{ marginLeft: "20px" }}>Total =  {genfunction.ccyFormat(apiData.TotalAmount ? apiData.TotalAmount : 0)}</Typography>
              </Grid>

              {bkngType.PayDepositOnly &&

                <Grid item xs={8} ms={8} lg={8}>
                  <Typography variant="h5" style={{ marginTop: "20px", marginLeft: "20px" }}>Total Due Today =  {genfunction.ccyFormat(state.amountSelected)}</Typography>
                </Grid>

              }
              <Grid item xs={4} ms={4} lg={4}>
                <Button variant="contained" size="small" color="primary" disabled={saveBtn || !isAddToCart} onClick={() => redirectCall()}>Add to Cart</Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div >
  );
}

export default ExtraItemDrawer;
